export default __webpack_public_path__ + "dist/media/Settings.576fbfb2.svg";